module.exports = __webpack_public_path__ + "img/00002.2cdf561f.webp";